import { type RouteRecordRaw } from 'vue-router'

export const brandKitRouter: RouteRecordRaw[] = [
  {
    component: {
      name: 'BrandKitRouterView',
      template: '<router-view></router-view>',
    },
    meta: {
      roles: ['pb:super'],
    },
    name: 'brand.brand-kit',
    path: 'brand-kit',
  },
]
